import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8a30166"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "c-checkbox-item"
}
const _hoisted_2 = {
  key: 1,
  class: "c-checkbox-item"
}
const _hoisted_3 = { class: "checkbox" }
const _hoisted_4 = ["disabled", "checked"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "dashboard__table-td--b dashboard__table-td--approve"
}
const _hoisted_7 = { class: "dashboard__table-column" }
const _hoisted_8 = {
  disabled: "",
  class: "to-approve-button"
}
const _hoisted_9 = {
  key: 0,
  class: "status-text status-text--bold"
}
const _hoisted_10 = {
  key: 1,
  class: "status-text status-text--bold"
}
const _hoisted_11 = {
  key: 2,
  class: "status-text",
  style: {"white-space":"break-spaces"}
}
const _hoisted_12 = {
  key: 1,
  class: "dashboard__table-td",
  style: {"border-left":"5px solid rgba(255, 165, 114, 1)","padding-left":"20px"}
}
const _hoisted_13 = {
  disabled: "",
  class: "on-order-button disabled"
}
const _hoisted_14 = {
  key: 2,
  class: "dashboard__table-td dashboard__table-td--pay"
}
const _hoisted_15 = { class: "dashboard__table-column" }
const _hoisted_16 = {
  key: 0,
  disabled: "",
  class: "to-pay-button"
}
const _hoisted_17 = {
  key: 1,
  disabled: "",
  class: "to-pay-status"
}
const _hoisted_18 = { class: "flex flex-col m-9" }
const _hoisted_19 = { class: "status-text status-text--bold" }
const _hoisted_20 = { class: "status-text" }
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = {
  key: 0,
  class: "status-text"
}
const _hoisted_23 = {
  key: 3,
  class: "flex flex-col m-9"
}
const _hoisted_24 = { class: "status-text" }
const _hoisted_25 = {
  key: 3,
  class: "dashboard__table-td dashboard__table-td--transport"
}
const _hoisted_26 = {
  disabled: "",
  class: "to-transport-button"
}
const _hoisted_27 = { class: "status-text m-9" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = {
  key: 4,
  class: "dashboard__table-td dashboard__table-td--process"
}
const _hoisted_33 = { class: "dashboard__table-column" }
const _hoisted_34 = {
  disabled: "",
  class: "processing-documents-button"
}
const _hoisted_35 = {
  key: 0,
  class: "status-text",
  style: {"white-space":"break-spaces"}
}
const _hoisted_36 = {
  key: 5,
  class: "dashboard__table-td dashboard__table-td--completed"
}
const _hoisted_37 = { class: "dashboard__table-column" }
const _hoisted_38 = {
  disabled: "",
  class: "completed-button"
}
const _hoisted_39 = { class: "status-text" }
const _hoisted_40 = { class: "status-text" }
const _hoisted_41 = { class: "status-text" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "CMR:", -1))
const _hoisted_43 = { class: "dashboard__table-td pr-0" }
const _hoisted_44 = { class: "dashboard__popup-item dashboard__carInfo-item c-orders-item-line" }
const _hoisted_45 = { class: "dashboard__table-text dashboard__normal c-table-body-font-12 c-bold" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = { class: "dashboard__table-td c+size-345" }
const _hoisted_48 = {
  class: "dashboard__popup-item dashboard__carInfo-item c-orders-item-line",
  style: {"border":"none"}
}
const _hoisted_49 = { class: "dashboard__table-column" }
const _hoisted_50 = { class: "c-order-item-car-info" }
const _hoisted_51 = { class: "dashboard__carInfo-info" }
const _hoisted_52 = { class: "dashboard__table-text dashboard__normal c-table-body-font-12" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = {
  key: 0,
  class: "dashboard__table-text dashboard__normal c-table-body-font-12 c-margin-6"
}
const _hoisted_55 = { class: "dashboard__table-text dashboard__normal c-table-body-font-12 c-margin-6" }
const _hoisted_56 = {
  key: 1,
  class: "dashboard__table-text dashboard__normal c-table-body-font-12 c-margin-6"
}
const _hoisted_57 = { class: "flex" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  class: "dashboard__table-td c+size-142",
  style: {"overflow":"visible"}
}
const _hoisted_61 = { class: "dashboard__popup-item dashboard__carInfo-item dashboard__carInfo-item--center c-orders-item-line" }
const _hoisted_62 = { class: "dashboard__table-text dashboard__normal c-table-body-font-12 c-bold" }
const _hoisted_63 = { class: "tooltip-content" }
const _hoisted_64 = { class: "image-container" }
const _hoisted_65 = ["src"]
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "text-container" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_70 = { class: "dashboard__table-td c+size-161" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-orders-item-line-last" }, null, -1))
const _hoisted_72 = { class: "dashboard__popup-column dashboard__popup-price c-price-details" }
const _hoisted_73 = { class: "dashboard__popup-priceBlock" }
const _hoisted_74 = { class: "text-right" }
const _hoisted_75 = { class: "dashboard__popup-priceBlock" }
const _hoisted_76 = { class: "text-right" }
const _hoisted_77 = { class: "dashboard__popup-priceBlock" }
const _hoisted_78 = { class: "text-right" }
const _hoisted_79 = { class: "dashboard__popup-priceBlock" }
const _hoisted_80 = {
  key: 0,
  class: "text-right"
}
const _hoisted_81 = {
  key: 1,
  class: "text-right"
}
const _hoisted_82 = {
  class: "dashboard__popup-priceBlock",
  "\"": ""
}
const _hoisted_83 = { class: "text-right" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"width":"100%","background":"#283747"} }, null, -1))
const _hoisted_86 = { class: "dashboard__popup-priceBlock" }
const _hoisted_87 = { class: "text-right" }
const _hoisted_88 = { class: "dashboard__table-column dashboard__table-column--stretch" }
const _hoisted_89 = {
  key: 3,
  style: {"width":"100%"}
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon dashboard__table-icon",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#decline" })
], -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "18",
  height: "18",
  src: "/img/list.svg",
  alt: "#"
}, null, -1))
const _hoisted_92 = { style: {"margin-left":"12px"} }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "18",
  height: "18",
  src: "/img/payment.svg",
  alt: "#"
}, null, -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"12px"} }, "View payment", -1))
const _hoisted_95 = {
  key: 4,
  class: "c-pickup-hours-label"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon dashboard__table-icon",
  width: "12",
  height: "12"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#icon-credit" })
], -1))
const _hoisted_97 = { class: "table-badge__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_format_currency = _resolveComponent("app-format-currency")!
  const _component_vue_tippy = _resolveComponent("vue-tippy")!
  const _component_p_calendar = _resolveComponent("p-calendar")!
  const _component_ConfirmDatePopup = _resolveComponent("ConfirmDatePopup")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_order_vehicle_table = _resolveComponent("order-vehicle-table")!
  const _component_upload_cmr_popup = _resolveComponent("upload-cmr-popup")!
  const _component_manual_transfer_popup = _resolveComponent("manual-transfer-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showCheckbox)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, [
              _createElementVNode("input", {
                disabled: _ctx.isFinalizingOrder,
                type: "checkbox",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectCar && _ctx.selectCar(...args))),
                checked: _ctx.isSelected
              }, null, 40, _hoisted_4),
              _createElementVNode("i", {
                style: _normalizeStyle(
                        _ctx.isFinalizingOrder
                            ? 'background: transparent; cursor: not-allowed'
                            : _ctx.isSelected
                            ? ''
                            : 'background: white'
                    )
              }, null, 4)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
      : (_openBlock(), _createElementBlock("tr", {
          key: 3,
          class: _normalizeClass(`dashboard__table-tr dashboard__table-order
        ${_ctx.orderStatusClass[String(_ctx.order?.status)]} ${
            !_ctx.isOrderInStatus(_ctx.orderStatusEnum.to_pay) && _ctx.isFinalizingOrder ? 'pending' : ''
        }
        ${_ctx.isSelected ? 'c-table-item-selected' : ''}
        ${_ctx.showDocuments ? 'show-documents' : ''}`),
          role: "row"
        }, [
          (_ctx.orderStatus === String('to_approve') || _ctx.orderStatus === '1')
            ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", _hoisted_8, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.to_approve.title" })
                  ]),
                  ([3].includes(_ctx.order.status.id))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.order.status.name), 1))
                    : _createCommentVNode("", true),
                  ([1, 2].includes(_ctx.order.status.id))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.order.status.name), 1))
                    : _createCommentVNode("", true),
                  (_ctx.order.status.id === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createVNode(_component_i18n_t, { keypath: "myOrders.transport_and_administration_fees" })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderStatus === String('on_order') || _ctx.orderStatus === '2')
            ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", _hoisted_13, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.on_order.title" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderStatus === String('to_pay') || _ctx.orderStatus === '3')
            ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.counters.allPayProcessingPayment > 0)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_16, [
                        _createVNode(_component_i18n_t, { keypath: "myOrders.to_pay.title" })
                      ]))
                    : (_ctx.counters.filteredPayProcessingPayment > 0)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_17, [
                          _createVNode(_component_i18n_t, { keypath: "myOrders.processing_payment.title" })
                        ]))
                      : _createCommentVNode("", true),
                  (_ctx.counters.allPayProcessingPayment > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, [
                            _createVNode(_component_i18n_t, { keypath: "myOrders.prePaid" }),
                            _createTextVNode(" : ")
                          ]),
                          _createElementVNode("span", _hoisted_20, [
                            _createVNode(_component_app_format_currency, {
                              value: _ctx.orderPaymentDto?.amount_paid_confirmed,
                              currency: "EUR"
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          (_ctx.counters.filteredPayAwaitingPayment > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.companyInfoTab.teamMembers.awaiting_payment" }),
                                _createTextVNode(": " + _toDisplayString(_ctx.counters.filteredPayAwaitingPayment), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.counters.filteredPayProcessingPayment > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, [
                          _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.companyInfoTab.teamMembers.processing_payment" }),
                          _createTextVNode(": " + _toDisplayString(_ctx.counters.filteredPayProcessingPayment), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderStatus === String('to_transport') || _ctx.orderStatus === '4')
            ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", _hoisted_26, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.to_transport.title" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.openTransportPlanningInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("span", null, [
                          _createVNode(_component_i18n_t, { keypath: "myOrders.planning_ongoing" }),
                          _createTextVNode(" :" + _toDisplayString(_ctx.counters.planningOnGoing), 1)
                        ]),
                        _hoisted_29,
                        _createElementVNode("span", null, [
                          _createVNode(_component_i18n_t, { keypath: "myOrders.transport_planned" }),
                          _createTextVNode(" : " + _toDisplayString(_ctx.counters.transportPlanned), 1)
                        ])
                      ]))
                    : (_ctx.openPickupDateReadyForPickupInfo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("span", null, [
                            _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.companyInfoTab.teamMembers.awaiting_pickup_date" }),
                            _createTextVNode(": " + _toDisplayString(_ctx.counters.transportAwaitingPickupDate), 1)
                          ]),
                          _hoisted_31,
                          _createElementVNode("span", null, [
                            _createVNode(_component_i18n_t, { keypath: "myOrders.ready_for_pickup" }),
                            _createTextVNode(" : " + _toDisplayString(_ctx.counters.transportReadyForPickup), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderStatus === String('processing_documents') || _ctx.orderStatus === '5')
            ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", _hoisted_34, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.processing_documents.title" })
                  ]),
                  (_ctx.openProcessingDocInfo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                        _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.companyInfoTab.teamMembers.your_car_documents" })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderStatus === String('completed') || _ctx.orderStatus === '6')
            ? (_openBlock(), _createElementBlock("td", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("button", _hoisted_38, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.completed.title" })
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("b", null, [
                      _createVNode(_component_i18n_t, { keypath: "myOrders.completed.description" }),
                      _createTextVNode(" : ")
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.order.date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("b", null, [
                      _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.companyInfoTab.teamMembers.payment_received" }),
                      _createTextVNode(":")
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.order.date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.order.date)), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("td", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("span", _hoisted_45, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.order?.date)), 1),
                _hoisted_46
              ])
            ])
          ]),
          _createElementVNode("td", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("span", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order?.description, (text) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: text }, [
                          _createTextVNode(_toDisplayString(text) + " ", 1),
                          _hoisted_53
                        ], 64))
                      }), 128))
                    ]),
                    (_ctx.order?.customer_reference)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_i18n_t, { keypath: "cart.customerReference" }),
                            _createTextVNode(" : ")
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.order.customer_reference), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_55, [
                      _createElementVNode("strong", null, [
                        _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.companyInfoTab.teamMembers.power_user" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.order.purchase_contact.firstname) + " " + _toDisplayString(_ctx.order.purchase_contact.lastname), 1)
                    ]),
                    (
                                    _ctx.orderStatus !== String('to_approve') &&
                                    _ctx.orderStatus !== '1'
                                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                          _createElementVNode("strong", null, [
                            _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.companyInfoTab.teamMembers.approver" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.order.purchase_contact.firstname) + " " + _toDisplayString(_ctx.order.purchase_contact.lastname), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["dashboard__table-text dashboard__normal c-table-body-font-12", 
                                    _ctx.isOrderInStatus(_ctx.orderStatusEnum.to_approve)
                                        ? 'c-margin-6'
                                        : 'c-margin-3'
                                ]),
                      style: {"margin-top":"6px"}
                    }, [
                      _createElementVNode("strong", null, [
                        _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.orderDeliveryLocation" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.order?.delivery_address.street) + " " + _toDisplayString(_ctx.order?.delivery_address.number) + " , " + _toDisplayString(_ctx.order?.delivery_address.zipcode) + " , " + _toDisplayString(_ctx.order?.delivery_address.country?.name), 1)
                    ], 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["dashboard__table-text dashboard__normal c-table-body-font-12", 
                                    _ctx.isOrderInStatus(_ctx.orderStatusEnum.to_approve)
                                        ? 'c-margin-6'
                                        : 'c-margin-3'
                                ])
                    }, [
                      _createElementVNode("strong", null, [
                        _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.transportType" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.order.transport_expeditor.name), 1)
                    ], 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["dashboard__table-text dashboard__normal c-table-body-font-12", 
                                    _ctx.isOrderInStatus(_ctx.orderStatusEnum.to_approve)
                                        ? 'c-margin-6'
                                        : 'c-margin-3'
                                ])
                    }, [
                      _createElementVNode("strong", null, [
                        _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.orderUserid" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.order?.id), 1)
                    ], 2),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["dashboard__table-text dashboard__normal c-table-body-font-12", 
                                        _ctx.isOrderInStatus(_ctx.orderStatusEnum.to_approve)
                                            ? 'c-margin-6'
                                            : 'c-margin-3'
                                    ])
                      }, [
                        _createElementVNode("strong", null, [
                          _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.proformaNumber" }),
                          _createTextVNode(" " + _toDisplayString(" "))
                        ]),
                        (_ctx.order?.backoffice_reference)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.order.backoffice_reference), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_59, [
                              _createVNode(_component_i18n_t, { keypath: "myOrders.notYetAvailable" })
                            ]))
                      ], 2),
                      (!(_ctx.order.status.id === 1) && _ctx.isEye)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            width: "16",
                            height: "16",
                            src: "/img/Vector.svg",
                            class: "eye",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewProformaOrder = _ctx.order))
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("td", _hoisted_60, [
            _createVNode(_component_vue_tippy, {
              interactive: "",
              placement: "right",
              animation: "shift-away",
              trigger: "mouseenter focus",
              hideOnClick: false,
              tag: "div",
              arrow: true,
              theme: "light",
              "update-on-content-resize": true
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_63, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderVehicles, (orderVehicle) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "tooltip-content-element",
                      key: orderVehicle.id.toString()
                    }, [
                      _createElementVNode("div", _hoisted_64, [
                        (orderVehicle?.thumbnail_image?.href_small)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: orderVehicle.thumbnail_image?.href_small
                            }, null, 8, _hoisted_65))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["no-image-block", _ctx.noImageBlockClassName])
                            }, [
                              _createElementVNode("img", {
                                style: {"height":"60%"},
                                src: `/img/${_ctx.brandLabel}/no-image.svg`
                              }, null, 8, _hoisted_66)
                            ], 2))
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("b", null, _toDisplayString(`${orderVehicle?.vehicle?.brand?.name} ${orderVehicle?.vehicle?.model}`), 1),
                        _hoisted_68,
                        _createTextVNode(" " + _toDisplayString(orderVehicle.vehicle.powertrain.motorisation) + " " + _toDisplayString(orderVehicle?.vehicle?.firstregistration_date
                                        ? " / " +
                                          _ctx.formatDate(
                                              orderVehicle?.vehicle
                                                  ?.firstregistration_date,
                                              "yyyy",
                                          )
                                        : "") + " ", 1),
                        _hoisted_69,
                        _createElementVNode("b", null, [
                          _createVNode(_component_app_format_currency, {
                            value: orderVehicle?.price_vehicle_ex_vat ?? 0,
                            currency: "EUR"
                          }, null, 8, ["value"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("span", _hoisted_62, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.order.vehicle_counter), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("td", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_i18n_t, { keypath: "cart.vehicles" })
                ]),
                _createElementVNode("strong", _hoisted_74, [
                  _createVNode(_component_app_format_currency, {
                    value: _ctx.orderPriceDetailDto?.total_price_vehicles_ex_vat ?? 0,
                    currency: "EUR"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_i18n_t, { keypath: "cart.transportFees" })
                ]),
                _createElementVNode("strong", _hoisted_76, [
                  _createVNode(_component_app_format_currency, {
                    value: 
                                _ctx.orderPriceDetailDto?.total_price_transport_ex_vat ?? 0
                            ,
                    currency: "EUR"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_i18n_t, { keypath: "cart.adminFees" })
                ]),
                _createElementVNode("strong", _hoisted_78, [
                  _createVNode(_component_app_format_currency, {
                    value: 
                                _ctx.orderPriceDetailDto?.total_price_admin_handling_ex_vat ??
                                0
                            ,
                    currency: "EUR"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_i18n_t, { keypath: "cart.vat" })
                ]),
                (_ctx.orderPriceDetailDto?.total_vat_amount != undefined)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_80, [
                      _createVNode(_component_app_format_currency, {
                        value: _ctx.orderPriceDetailDto?.total_vat_amount ?? 0,
                        currency: "EUR"
                      }, null, 8, ["value"])
                    ]))
                  : (_openBlock(), _createElementBlock("strong", _hoisted_81, "TBD"))
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_i18n_t, { keypath: "cart.dealReduction" })
                ]),
                _createElementVNode("strong", _hoisted_83, [
                  _createVNode(_component_app_format_currency, {
                    value: (_ctx.orderPriceDetailDto?.deal_reduction > 0 ? -_ctx.orderPriceDetailDto?.deal_reduction : 0),
                    currency: "EUR"
                  }, null, 8, ["value"])
                ])
              ]),
              _hoisted_84,
              _hoisted_85,
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_i18n_t, { keypath: "cart.subtotal" })
                ]),
                _createElementVNode("strong", _hoisted_87, [
                  (
                                _ctx.orderPriceDetailDto?.total_price_including_vat !=
                                undefined
                            )
                    ? (_openBlock(), _createBlock(_component_app_format_currency, {
                        key: 0,
                        value: _ctx.orderPriceDetailDto.total_price_including_vat,
                        currency: "EUR"
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("TBD")
                      ], 64))
                ])
              ])
            ])
          ]),
          _createElementVNode("td", {
            class: _normalizeClass(["dashboard__table-td", `${
                _ctx.showDocuments && (_ctx.orderStatus === '4' || _ctx.orderStatus === '5')
                    ? 'c-size-220'
                    : 'c-size-117'
            }`])
          }, [
            _createElementVNode("div", _hoisted_88, [
              true
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (
                            !_ctx.showDocuments &&
                            (_ctx.orderStatus === String('to_pay') || _ctx.orderStatus === '3')
                        )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "dashboard__table-btn gray",
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirectToOrderDetailsAvailable(_ctx.orderStatus)))
                        }, [
                          _createVNode(_component_i18n_t, { keypath: "myOrders.pay" })
                        ]))
                      : _createCommentVNode("", true),
                    (
                            _ctx.openPayAllButton &&
                            (_ctx.orderStatus === String('to_pay') || _ctx.orderStatus === '3')
                        )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "dashboard__table-btn gray",
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showPayAllPopup && _ctx.showPayAllPopup(...args)))
                        }, [
                          _createVNode(_component_i18n_t, { keypath: "cart.payAll" })
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.orderStatus === 'to_transport') && _ctx.openPickupDateButton)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "dashboard__table-btn",
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectToOrderDetailsAvailable(_ctx.orderStatus))),
                          style: {"background":"rgba(91, 114, 218, 1)"}
                        }, [
                          _createVNode(_component_i18n_t, { keypath: "cart.pickupDate" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orderStatus === '4' && _ctx.openPickupDateButton)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                          (_ctx.showDatePicker)
                            ? (_openBlock(), _createBlock(_component_p_calendar, {
                                key: 0,
                                style: {"position":"absolute","opacity":"0","height":"1.875rem"},
                                id: "range",
                                "input-style": 'cursor: pointer',
                                "min-date": new Date(Date.now() + 48 * 60 * 60 * 1000),
                                "max-date": new Date(Date.now() + 15 * 24 * 60 * 60 * 1000),
                                dateFormat: "dd/mm/yy",
                                selectionMode: "range",
                                manualInput: false,
                                "onUpdate:modelValue": _ctx.handleDateSelected
                              }, null, 8, ["min-date", "max-date", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "dashboard__table-btn",
                            type: "button",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getDatePicker())),
                            style: {"background":"rgba(91, 114, 218, 1)"}
                          }, [
                            _createVNode(_component_i18n_t, { keypath: "cart.pickupDateForAll" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showConfirmPopup)
                      ? (_openBlock(), _createBlock(_component_ConfirmDatePopup, {
                          key: 4,
                          _vehiclesId: _ctx.vehicleIds,
                          "onUpdate:_vehiclesId": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vehicleIds) = $event)),
                          _order: _ctx.order,
                          "onUpdate:_order": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.order) = $event)),
                          _formattedDate: _ctx.formattedSelectedDate,
                          "onUpdate:_formattedDate": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formattedSelectedDate) = $event)),
                          onCloseConfirmPopup: _ctx.closeConfirmPopup
                        }, null, 8, ["_vehiclesId", "_order", "_formattedDate", "onCloseConfirmPopup"]))
                      : _createCommentVNode("", true),
                    (
                            (_ctx.orderStatus === String('to_approve') ||
                                _ctx.orderStatus === '1') &&
                            _ctx.order.status.id === 3
                        )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          class: "dashboard__table-btn",
                          type: "button",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.approveOrder(_ctx.order))),
                          style: {"background":"var(--color-primary)"}
                        }, [
                          _createVNode(_component_i18n_t, { keypath: "myOrders.approve" })
                        ]))
                      : _createCommentVNode("", true),
                    (
                            (_ctx.orderStatus === 'processing_documents' &&
                                _ctx.openProcessingDocInfo) ||
                            (_ctx.orderStatus === '5' &&
                                _ctx.openProcessingDocInfo &&
                                !_ctx.showDocuments)
                        )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 6,
                          class: "dashboard__table-btn",
                          type: "button",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.redirectToOrderDetailsAvailable(_ctx.orderStatus))),
                          style: {"background":"rgba(249, 198, 17, 1)"}
                        }, " Upload CMR "))
                      : _createCommentVNode("", true),
                    (
                            _ctx.orderStatus === '5' && _ctx.openProcessingDocInfo && _ctx.showDocuments
                        )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 7,
                          class: "dashboard__table-btn",
                          type: "button",
                          onClick: _cache[11] || (_cache[11] = () => (_ctx.showUploadCmr = true)),
                          style: {"background":"rgba(249, 198, 17, 1)"}
                        }, " UPLOAD CMR FOR ALL "))
                      : _createCommentVNode("", true),
                    (
                            (_ctx.orderStatus === String('to_approve') ||
                                _ctx.orderStatus === '1') &&
                            _ctx.order.status.id === 3
                        )
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 8,
                          class: "dashboard__table-link",
                          title: "Decline",
                          style: {"text-decoration":"underline"},
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openDecline(_ctx.order.id)))
                        }, [
                          _hoisted_90,
                          _createElementVNode("span", null, [
                            _createVNode(_component_i18n_t, { keypath: "myOrders.to_approve.decline" })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.orderStatus === String('on_order') || _ctx.orderStatus === '2')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                : _createCommentVNode("", true),
              (!_ctx.showDocuments)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    class: "dashboard__table-link",
                    to: {
                        path: `/auth/my-carconnex/my-orders/${_ctx.orderStatus}/order-details/${_ctx.order.id}`,
                    },
                    onClick: _cache[13] || (_cache[13] = _withModifiers(() => _ctx.redirectToOrderDetails, ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_91,
                      _createElementVNode("span", _hoisted_92, [
                        _createVNode(_component_i18n_t, { keypath: "myOrders.viewOrderDetails" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              (_ctx.orderStatus === String('to_pay') || _ctx.orderStatus === '3')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    class: "dashboard__table-link",
                    to: "",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openPaymentsTransactionsPopup(_ctx.order.id)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_93,
                      _hoisted_94
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ((_ctx.orderStatus === String('to_transport')) && _ctx.openPickupDateButton)
                ? (_openBlock(), _createElementBlock("span", _hoisted_95, [
                    _createElementVNode("b", null, [
                      _createVNode(_component_i18n_t, { keypath: "myOrders.pickupHours" }),
                      _createTextVNode(":")
                    ]),
                    _createTextVNode(" 08:00 - 16:00 ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["dashboard__table-badge table-badge", 
                    _ctx.order.type.id === 1 ? 'table-badge--online' : 'table-badge--offline'
                ])
            }, [
              _hoisted_96,
              _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.order.type.id === 1 ? "online" : "key account"), 1)
            ], 2)
          ], 2)
        ], 2)),
    (_ctx.showDocuments)
      ? (_openBlock(), _createBlock(_component_order_vehicle_table, {
          key: 4,
          order: _ctx.order,
          orderVehicles: _ctx.orderVehicles,
          orderStatus: _ctx.orderStatus,
          _selectedCars: _ctx.selectedCars,
          "onUpdate:_selectedCars": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedCars) = $event)),
          _isPaymentsTransactionsPopup: _ctx.isPaymentsTransactionsPopup,
          "onUpdate:_isPaymentsTransactionsPopup": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isPaymentsTransactionsPopup) = $event)),
          _orderPaymentDto: _ctx.orderPaymentDto,
          "onUpdate:_orderPaymentDto": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.orderPaymentDto) = $event)),
          _orderId: _ctx.orderId,
          "onUpdate:_orderId": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.orderId) = $event)),
          fetchOrders: _ctx.fetchOrders
        }, null, 8, ["order", "orderVehicles", "orderStatus", "_selectedCars", "_isPaymentsTransactionsPopup", "_orderPaymentDto", "_orderId", "fetchOrders"]))
      : _createCommentVNode("", true),
    (_ctx.showUploadCmr)
      ? (_openBlock(), _createBlock(_component_upload_cmr_popup, {
          key: 5,
          onClosePopup: _ctx.closeUploadCmr,
          _orderId: _ctx.order.id,
          "onUpdate:_orderId": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.order.id) = $event)),
          _vehiclesId: _ctx.vehicleIds,
          "onUpdate:_vehiclesId": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.vehicleIds) = $event))
        }, null, 8, ["onClosePopup", "_orderId", "_vehiclesId"]))
      : _createCommentVNode("", true),
    (_ctx.showPay)
      ? (_openBlock(), _createBlock(_component_manual_transfer_popup, {
          key: 6,
          onClose: _cache[21] || (_cache[21] = () => (_ctx.showPay = false)),
          _orderId: _ctx.order.id,
          "onUpdate:_orderId": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.order.id) = $event)),
          _vehiclesId: _ctx.vehicleIds,
          "onUpdate:_vehiclesId": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.vehicleIds) = $event)),
          _isProcessingPayment: _ctx.everyVeInProcessingPayments,
          "onUpdate:_isProcessingPayment": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.everyVeInProcessingPayments) = $event))
        }, null, 8, ["_orderId", "_vehiclesId", "_isProcessingPayment"]))
      : _createCommentVNode("", true)
  ], 64))
}